const swal = {
  success(message = 'Success') {
    return Swal.fire({
      icon: 'success',
      text: message,
      showConfirmButton: false,
      timer: 1500,
    })
  },

  error(message = 'Something went wrong!') {
    return Swal.fire({
      icon: 'error',
      text: message,
      confirmButtonText: 'OK',
    })
  },

  confirm({
    title = 'Are you sure?',
    text = 'This action cannot be undone.',
    confirmButtonText = 'Yes, proceed',
    cancelButtonText = 'Cancel',
    icon = 'warning'
  } = {}) {
    return Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText,
      cancelButtonText,
    })
  },

  info(message = '') {
    return Swal.fire({
      icon: 'info',
      text: message,
      showConfirmButton: false,
      timer: 1500,
    })
  },

  loading(title = 'Loading...') {
    return Swal.fire({
      title,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    })
  },

  close() {
    Swal.close()
  }
}

export default swal
